import { render, staticRenderFns } from "./CalendarListAddNew.vue?vue&type=template&id=35bf44ca"
import script from "./CalendarListAddNew.vue?vue&type=script&lang=js"
export * from "./CalendarListAddNew.vue?vue&type=script&lang=js"
import style0 from "./CalendarListAddNew.vue?vue&type=style&index=0&id=35bf44ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports